import React from 'react';
import './HomeCard.css';
import { Card } from '../common/components/Cards';
import { Button } from '../common/components/Button';
import { BulletedList, BulletedListItem, Icon } from '@emorg-prd/standard-react';
import HomeCardData from '../../utils/HomeCardData';

interface HomeCardProps {
	info: HomeCardData;
}

interface HomeCardState { }

export default class HomeCard extends React.Component<HomeCardProps, HomeCardState> {

	render() {
		const darkModeEnabled = localStorage.getItem('theme') === 'dark';
		
		const handleCardClick = () => {
			if (this.props.info.startingLink) {
				this.props.info.external
					? window.open(this.props.info.startingLink, '_blank', 'noopener')
					: window.open(this.props.info.startingLink, '_self');
			}
		};

		const cardContent = (
			<>
				<div>
					<p>{this.props.info.description}</p>
					
					{this.props.info.actions?.length > 0 && (
						<BulletedList>
							{this.props.info.actions.map((action, index) => (
								<BulletedListItem key={index}>
									<strong>{action.toUpperCase()}</strong>
								</BulletedListItem>
							))}
						</BulletedList>
					)}
					
					{this.props.info.additionalLinks?.length > 0 && (
						<div className="additional-links">
							{this.props.info.additionalLinks.map((link, index) => (
								<a
									key={index}
									href={link.href}
									target="_blank"
									rel="noopener noreferrer"
									className="additional-link"
								>
									{link.label}
								</a>
							))}
						</div>
					)}
				</div>
				
				{this.props.info.startingLink && (
					<div style={{ marginTop: 'auto', paddingTop: '1rem' }}>
						<Button
							variant="tertiary"
							isLoading={false}
							disabled={false}
							name="GET STARTED"
							loadingVariant="tertiary"
							onClick={() => handleCardClick()}
						>
							<span><strong>GET STARTED</strong>&nbsp;</span>
							<Icon name="arrow-right" size="em-c-icon--small" />
						</Button>
					</div>
				)}
			</>
		);

		return (
			<Card
				kicker={this.props.info.kicker}
				title={this.props.info.title}
				cardType="blue"
				onClick={this.props.info.startingLink ? handleCardClick : undefined}
				className={`home-card ${this.props.info.startingLink ? 'em-c-custom-pointer' : ''} ${darkModeEnabled ? 'dark-theme' : ''}`}
			>
				{cardContent}
			</Card>
		);
	}
}